module.exports = __webpack_public_path__ + "static/media/pay.50e472e8.svg";